import React, { useCallback, useState } from "react";
import Typography from "components/Typography";
import { Modal } from "components/Modal";
import { FieldInput } from "components/form/FieldInput";
import Button from "components/Button";
import classes from "./DeliveryFeeModal.module.css";

const DeliveryFeeModal = ({ show, onClose, onSubmit }) => {
  const [value, setValue] = useState("");

  const onChange = useCallback(
    (e) => setValue(e.target.value),
    [setValue]
  );

  return (
    <Modal
      modalClassnames={classes.modal}
      show={show}
      onClose={onClose}
      variant="basic"
    >
      <Typography variant="headline" size="m">
        Adjust delivery fee
      </Typography>

      <div className="t-20 b-20">
        <FieldInput
          label="Delivery fee, $"
          masked
          value={value}
          onChange={onChange}
          maxLength={7}
          hideMaxLength
        />
      </div>
      <div className="df t-20">
        <div className="r-20 r-m-32">
          <Button secondary label="Cancel" onClick={onClose} />
        </div>
        <Button label="Confirm" onClick={() => onSubmit(value)} />
      </div>
    </Modal>
  );
};

export default DeliveryFeeModal;
